import { useScreenSize } from '@hooks';
import { Flex, theme, Typography } from '@styles';
import { ReactComponent as ArrowIcon } from '@svgs/chevron-right.svg';
import { arrayOf, object } from 'prop-types';
import React from 'react';

import { Icon } from '../Icon';

const CourseStructure = ({ modules }) => {
  const { isTabletSM } = useScreenSize();

  if (isTabletSM) {
    return (
      <Flex flexDirection="column" gap={16}>
        {modules?.map((item, index) => (
          <Flex alignItems="center" gap={10}>
            <Flex
              alignItems="center"
              bg={theme.colors.white[10]}
              borderColor={theme.colors.white[10]}
              borderRadius={1}
              borderStyle="solid"
              borderWidth={1}
              height={48}
              justifyContent="center"
              pt={1}
              width={48}
            >
              <Typography
                color={theme.colors.white[100]}
                variant="BN-bold-s21-lh19"
              >
                {index + 1}
              </Typography>
            </Flex>
            <Typography
              color={theme.colors.silver[100]}
              textAlign="center"
              variant="MS-regular-s16-lh25"
            >
              {item?.title}
            </Typography>
          </Flex>
        ))}
      </Flex>
    );
  }

  return (
    <Flex justifyContent="space-around" px={16}>
      {modules?.map((item, index) => (
        <>
          <Flex
            alignItems="center"
            flexDirection="column"
            gap={24}
            width="calc(16.6% - 34px)"
          >
            <Flex
              alignItems="center"
              bg={theme.colors.white[10]}
              borderColor={theme.colors.white[10]}
              borderRadius={3}
              borderStyle="solid"
              borderWidth={2}
              height={93}
              justifyContent="center"
              pt={2}
              width={93}
            >
              <Typography
                color={theme.colors.white[100]}
                variant="BN-bold-s43-lh38"
              >
                {index + 1}
              </Typography>
            </Flex>
            <Typography
              color={theme.colors.silver[100]}
              textAlign="center"
              variant="MS-semibold-s18-lh19"
            >
              {item?.title}
            </Typography>
          </Flex>
          {index !== modules.length - 1 && (
            <Icon
              color={theme.colors.white[100]}
              height={34}
              mt={32}
              opacity={0.3}
              SVG={ArrowIcon}
              width={34}
            />
          )}
        </>
      ))}
    </Flex>
  );
};

CourseStructure.propTypes = {
  modules: arrayOf(object).isRequired,
};

export default CourseStructure;
